import { redTint, red, grey, blue } from 'web-ui-kit/colors';

import { createRequestTypes } from '../creators';

export const ENVIRONMENTS = [
  'dev',
  'staging',
  'prod'
];

export const EDIT_PROFILE = 'EDIT_PROFILE';
export const CHANGE_EMAIL = 'CHANGE_EMAIL';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';

// Login
export const LoginFields = { USERNAME: 'username', PASSWORD: 'password' };

// Studio
export const NAV_BAR_ID = 'app-navigation-bar';
export const STUDIO_BANNER_ID = 'studioBannerContain';

// form
export const BillingFormFieldNames = {
  BILLING_ADDRESS_NAME: 'billingAddressName',
  BILLING_STREET_ADDRESS: 'billingStreetAddress',
  BILLING_CITY: 'billingCity',
  BILLING_STATE: 'billingState',
  BILLING_ZIP: 'billingZipcode',
  BILLING_COUNTRY: 'billingCountry',
  SHIPPING_ADDRESS_NAME: 'shippingAddressName',
  SHIPPING_STREET_ADDRESS: 'shippingStreetAddress',
  SHIPPING_PHONE_NUMBER: 'shippingPhoneNumber',
  SHIPPING_CITY: 'shippingCity',
  SHIPPING_STATE: 'shippingState',
  SHIPPING_ZIP: 'shippingZipcode',
  SHIPPING_COUNTRY: 'shippingCountry',
  CARD_NAME: 'cardName',
  CARD_NUMBER: 'cardNumber',
  EXPIRE_MONTH: 'expireMonth',
  EXPIRE_YEAR: 'expireYear',
  CVC: 'cvc',
  SAVECC: 'saveCC',
  PROMO_CODE: 'promoCode',
  EMAIL: 'email',
  PASSWORD: 'password',
  REFERRAL: 'referral',
  OTHER_REFERAL_ANSWER: 'other_referral_answer'
};

// Account Form
export const AccountFields = {
  FIRSTNAME: 'firstName',
  LASTNAME: 'lastName',
  OLDPASS: 'oldPass',
  NEWPASS: 'newPass',
  CONFIRMPASS: 'confirmPass',
  EMAIL: 'email',
  EMAILPASS: 'emailPass'
};
// QUESTIONS
export const Questions = {
  ROOMS: [
    ['1', 'Living Room'],
    ['999', 'Open Living / Dining Room'],
    ['6', 'Bedroom'],
    ['4', 'Office'],
    ['2', 'Dining Room'],
    ['10', 'Entryway'],
    ['9', 'Nursery'],
    ['8', "Kid's Bedroom"],
    ['11', 'Studio']
    // ["3", 'Family Room'],
    // ["5", 'Guest Room'],
    // ["7", 'Guest Bedroom'],
  ],
  OTHER_ROOM_ID: '9999',
  OTHER_GOAL_ID: '9999',
  OTHER_STYLE_ID: '9999',
  STYLE_NOT_SURE_ID: '6',
  // NOTE: Should return these values from the server
  GOALS_TO_USE: [
    ['1', "I'm redecorating"],
    ['2', "I'm moving"],
    ['3', 'I need help with a layout'],
    ['4', "I'm looking for a few specific pieces (rug, sofa, etc.)"],
    ['5', "I'm moving in with someone"]
  ],
  STYLES: [
    ['1', 'Modern and Minimal'],
    ['2', 'Rustic and Warm'],
    ['3', 'Traditional and Comfortable'],
    ['4', 'Urban and Trendy'],
    ['5', 'Dramatic and Bold'],
    ['9999', 'Other'],
    ['6', "I'm not sure about my style"]
  ],
  WORKFLOW: ['room', 'goal', 'furniture', 'budget', 'style'],
  SCOPES_TO_USE: [
    [0, 'Starting from scratch', "I'm designing the whole room"],
    [
      1,
      'Somewhere in between',
      "I'm designing around a few pieces I already own"
    ],
    [2, 'Mostly furnished', 'I want to put the finishing touches on my room']
  ]
};

// Page Type constants for Welcome Page
export const WP_INITIAL = 'init';
export const WP_NEW_USER_WITHOUT_STYLEQUIZ = 'no_stylequiz';
export const WP_NEW_USER_WITH_STYLEQUIZ = 'completed_stylequiz';

export const SPACE_TYPE_CHOICES = {
  1: 'Living Room',
  999: 'Open Living / Dining',
  6: 'Master Bedroom',
  4: 'Office',
  2: 'Dining Room',
  10: 'Entry',
  9: 'Nursery',
  // 3: "Family Room",
  // 5: "Guest Room",
  // 7: "Guest Bedroom",
  8: "Kid's Bedroom",
  11: 'Studio'
  // 9999: "Other"
};

export const DesignState = { ACTIVE: 'ready', PENDING: 'pending' };

export const DesignSource = {
  INITIAL: 'initial_design',
  REDESIGN: 'redesign',
  REPLACE: 'replace'
};

export const BillingFormState = { SHIPPING: 0, BILLING: 1, PAYMENT: 2 };

export const PackageType = { PACKAGE: 0, REPLACE: 1, PRODUCT: 26 };

// Onboarding
export const SHOWROOM_ONBOARDING_ID = {
  STEP_1_DESKTOP: 'showroom-onboarding-step1-desktop',
  STEP_2_DESKTOP: 'showroom-onboarding-step2-desktop',
  STEP_3_DESKTOP: 'showroom-onboarding-step3-desktop',
  STEP_1_MOBILE: 'showroom-onboarding-step1-mobile',
  STEP_2_MOBILE: 'showroom-onboarding-step2-mobile',
  STEP_3_MOBILE: 'showroom-onboarding-step3-mobile'
};

// Assistance Request
export const REDESIGN_TAT = '4-7';

// Dashboard
export const DashboardTab = {
  STYLE_QUIZ: 'stylequiz',
  PHOTOS: 'pm',
  MOODBOARD: 'moodboard',
  CUSTOM_PROP: 'custom_prop'
};

export const PhotoPhase = {
  INSTRUCTIONS: 0,
  PHOTO: 1,
  MEASURE: 2,
  COMPLETE: 3
};

export const StyleQuizStatus = {
  COMPLETE: 'completed',
  NOT_STARTED: 'not_started'
};

export const SpaceStatus = {
  INIT: 'init',
  READY: 'ready',
  REVIEWING: 'under modsy review',
  IN_PROGRESS: 'inprogress',
  DESIGNS_PENDING: 'initial designs pending',
  PENDING: 'pending'
};

export const DashProgress = {
  INITIAL: 0,
  STYLE_QUIZ_COMPLETE: 1,
  PHOTOS_COMPLETE: 2,
  MOODBOARD_COMPLETE: 3
};

export const MeasurementFields = {
  LENGTH: 'length',
  WIDTH: 'width',
  HEIGHT: 'height',
  UNIT: 'unit',
  COMMENTS: 'comments'
};

export const DashStatus = {
  NOT_STARTED: 'not_started',
  PENDING: 'pending',
  APPROVED: 'approved',
  NG: 'ng'
};

export const SpaceFlags = {
  styleQuiz: 'showTipStyleQuizCompleted',
  pAndMSubmitted: 'showTipPMSubmitted',
  pAndMApproved: 'showTipPMApproved',
  moodboard: 'showTipMoodboardCompleted',
  designsReady: 'showTipDesignReady'
};

export const MoodboardStatus = {
  PENDING: 'pending',
  READY: 'ready',
  SUBMITTED: 'submitted'
};

export const AllDashboardFlags = [
  SpaceFlags.moodboard,
  SpaceFlags.pAndMApproved,
  SpaceFlags.pAndMSubmitted,
  SpaceFlags.styleQuiz
];

export const sections = {
  Shipping: 'Shipping Address',
  Billing: 'Billing Address',
  Payment: 'Payment Info'
};

export const SIGNUP_FORM_FIELDS = { email: 'email', password: 'password' };

export const StyleResultMoodboardMap = {
  'Mod Visionary': 'MB-mod-vis-LR-F-2016',
  'Contemporary Minimalist': 'MB-contemporary-min-LR-F-2016',
  'Refined Farmhouse': 'MB-refined-farmhouse-LR-F-2016',
  'Industrial Visionary': 'MB-industrial-vis-LR-F-2016',
  'Discerning Collector': 'MB-discerning-collector-LR-F-2016',
  'Less is More Chic': 'MB-less-is-more-chic-LR-F-2016',
  'Rustic Minimalist': 'MB-rustic-min-LR-F-2016',
  'Refined Connoisseur': 'MB-refined-connoisseur-LR-F-2016',
  'Mod Enthusiast': 'MB-mod-enthusiast-LR-F-2016',
  'Modern Rustic': 'MB-modern-rustic-LR-F-2016',
  'Atomic Industrial': 'MB-atomic-industrial-LR-F-2016',
  'Mod Collector': 'MB-mod-collector-LR-F-2016',
  'Mid-Century Chic': 'MB-mid-century-chic-LR-F-2016',
  'Modern Vintage': 'MB-modern-vintage-LR-F-2016',
  'Refined Modern': 'MB-refined-modern-LR-F-2016',
  'Rustic Warmth': 'MB-rustic-warmth-LR-F-2016',
  'Inviting Industrial': 'MB-inviting-industrial-LR-F-2016',
  'Contemporary Collector': 'MB-contemporary-collector-LR-F-2016',
  'Comfortably Chic': 'MB-comfortably-chic-LR-F-2016',
  'Updated Traditional': 'MB-updated-traditional-LR-F-2016',
  'Contemporary Connoisseur': 'MB-contemporary-connoisseur-LR-F-2016',
  'Reclaimed Visionary': 'MB-reclaimed-vis-LR-F-2016',
  'Rustic Traveler ': 'MB-rustic-traveler-LR-F-2016',
  'Farmhouse Chic': 'MB-farmhouse-chic-LR-F-2016',
  'Vintage Farmhouse': 'MB-vintage-farmhouse-LR-F-2016',
  'Refined Rustic': 'MB-refined-rustic-LR-F-2016',
  'Urban Collector': 'MB-urban-collector-LR-F-2016',
  'Industrial Chic': 'MB-industrial-chic-LR-F-2016',
  'Urban Traditional': 'MB-urban-traditional-LR-F-2016',
  'Refined Industrial': 'MB-refined-industrial-LR-F-2016',
  'Chic Collector': 'MB-chic-collector-LR-F-2016',
  'Traditional Collector': 'MB-traditional-collector-LR-F-2016',
  'Classic Collector': 'MB-classic-collector-LR-F-2016',
  'Traditionally Chic': 'MB-traditionally-chic-LR-F-2016',
  'Elegant Connoisseur': 'MB-elegant-connoisseur-LR-F-2016',
  'Timeless Traditional': 'MB-timeless-traditional-LR-F-2016'
};

export const ReplacementStatus = { Remove: 'remove' };

export const URGENCIES = {
  1: 'Yes',
  2: 'Not now',
  3: 'No'
};

export const IMAGE_SIZES = {
  SMALL: '_small',
  MEDIUM: '_medium',
  LARGE: '_large'
};

export const MODSY_GIFT_CARD_URL = 'http://www.modsy.com/modsy-gift-cards/';

export const S3_URL = 'https://s3-us-west-2.amazonaws.com/modsy';

// Retail partner constants.
export const CRATE_AND_BARREL_PRODUCT_CODE = 'nju9a';
export const CRATE_AND_BARREL_URL_QUERY_CODE = 'crate-and-barrel';
export const WEST_ELM_URL_QUERY_CODE = 'west-elm';
export const CB2_URL_QUERY_CODE = 'cb2';
export const OVERSTOCK_URL_QUERY_CODE = 'overstock';
export const CLEVER_URL_QUERY_CODE = 'clever';
export const PARTNER_QUERY_KEY = 'prtnr';
export const PARTNERS_PURCHASE_THROUGH_MODSY = [
  OVERSTOCK_URL_QUERY_CODE,
  CLEVER_URL_QUERY_CODE
];

export const RETAIL_PARTNER_CONSTANTS = {
  CRATE_AND_BARREL_PRODUCT_CODE,
  CRATE_AND_BARREL_URL_QUERY_CODE,
  WEST_ELM_URL_QUERY_CODE,
  CB2_URL_QUERY_CODE
};

// export const S3_BASE_URL = process.env.REACT_APP_S3_BASE_URL;
// TODO: Use ENVs
export const S3_BASE_URL = 'https://s3-us-west-2.amazonaws.com/modsy';
export const S3_PARTNER_LOGOS_URL = `${S3_BASE_URL}/client/post-purchase-onboarding/partner_logos`;
export const S3_ADD_TO_CART_URL = `${S3_BASE_URL}/client/post-purchase-onboarding/add_to_cart`;

export const SPACE_TYPES = {
  LIVING_ROOM: 1,
  DINING_ROOM: 2,
  OFFICE_ROOM: 4,
  MASTER_BEDROOM: 6,
  KIDS_ROOM: 8,
  NURSERY_ROOM: 9,
  ENTRY_ROOM: 10,
  STUDIO_ROOM: 11,
  OPEN_LIVING_DINING_ROOM: 999
};

export const SPACE_TYPE_SLUG_MAP = {
  [SPACE_TYPES.LIVING_ROOM]: 'living-room',
  [SPACE_TYPES.DINING_ROOM]: 'dining-room',
  [SPACE_TYPES.OFFICE_ROOM]: 'home-office',
  [SPACE_TYPES.MASTER_BEDROOM]: 'bedroom',
  [SPACE_TYPES.KIDS_ROOM]: 'kids-bedroom',
  [SPACE_TYPES.NURSERY_ROOM]: 'nursery',
  [SPACE_TYPES.ENTRY_ROOM]: 'entryway',
  [SPACE_TYPES.STUDIO_ROOM]: 'studio-apartment',
  [SPACE_TYPES.OPEN_LIVING_DINING_ROOM]: 'open-living-dining-room'
};

export const SPACE_TYPE_STRING_MAP = {
  [SPACE_TYPES.LIVING_ROOM]: 'Living Room',
  [SPACE_TYPES.DINING_ROOM]: 'Dining Room',
  [SPACE_TYPES.OFFICE_ROOM]: 'Office',
  [SPACE_TYPES.MASTER_BEDROOM]: 'Bedroom',
  [SPACE_TYPES.KIDS_ROOM]: "Kid's Bedroom",
  [SPACE_TYPES.NURSERY_ROOM]: 'Nursery',
  [SPACE_TYPES.ENTRY_ROOM]: 'Entryway',
  [SPACE_TYPES.STUDIO_ROOM]: 'Studio',
  [SPACE_TYPES.OPEN_LIVING_DINING_ROOM]: 'Open Living / Dining Room'
};

export const SPACE_TYPE_IMG_MAP = {
  [SPACE_TYPES.LIVING_ROOM]: 'living-room.jpg',
  [SPACE_TYPES.DINING_ROOM]: 'dining-room.jpg',
  [SPACE_TYPES.OFFICE_ROOM]: 'office.jpg',
  [SPACE_TYPES.MASTER_BEDROOM]: 'bedroom.jpg',
  [SPACE_TYPES.KIDS_ROOM]: 'kid-bedroom.jpg',
  [SPACE_TYPES.NURSERY_ROOM]: 'nursery.jpg',
  [SPACE_TYPES.ENTRY_ROOM]: 'entryway.jpg',
  [SPACE_TYPES.STUDIO_ROOM]: 'studio.jpg',
  [SPACE_TYPES.OPEN_LIVING_DINING_ROOM]: 'open-living-dining.jpg'
};

const SKIP = 's';
const CONTINUE = 'c';
const NOT_SELECTED = 'n';
export const SCREEN_STATUS_CHOICES = {
  SKIP,
  CONTINUE,
  NOT_SELECTED
};

export const STYLEQUIZ_STATUS = {
  COMPLETED: 'completed',
  NOT_STARTED: 'not_started'
};

export const SPACE_STATUS = {
  PENDING: 'pending',
  READY: 'ready',
  REVIEW: 'under modsy review',
  DESIGNS_PENDING: 'initial designs pending',
  PRE_PURCHASE: 'pre-purchase',
  IN_PROGRESS: 'inprogress'
};

export const SPACE_STATUS_INT = {
  PENDING: 0,
  READY: 1,
  REVIEW: 7,
  PRE_PURCHASE: 8,
  IN_PROGRESS: 9,
  DESIGNS_PENDING: 10,
  ABANDONED: -1,
  UNKNOWN: -2
};

export const DESIGN_STATUS_INT = {
  IN_PROGRESS: 0,
  ABANDONED: 1,
  ACTIVE: 2,
  PENDING: 4,
  READY: 5,
  REJECTED: 6,
  UNKNOWN: -1
};

export const SPACE_STATUS_STRINGS = {
  0: 'pending',
  1: 'ready',
  7: 'under modsy review',
  8: 'pre-purchase',
  9: 'inprogress',
  10: 'initial designs pending'
};

export const PM_STATUS = {
  NOT_STARTED: 'not_started',
  PENDING: 'pending',
  APPROVED: 'approved',
  NG: 'ng'
};

export const ME_STATUS = {
  NOT_STARTED: 'not_started',
  PENDING: 'pending',
  APPROVED: 'approved',
  NG: 'ng'
};

export const MOODBOARD_STATUS = {
  PENDING: 'pending',
  READY: 'ready',
  SUBMITTED: 'submitted'
};

export const CONSTANTS = {
  SUBMIT_SPACE: createRequestTypes('dashboard', 'SUBMIT_SPACE'),
  CHANGE_PROFILE: createRequestTypes('profile', 'CHANGE_EMAIL'),
  SUBMIT_MOODBOARD: createRequestTypes('moodboard', 'SUBMIT_MOODBOARD'),
  GET_PAYMENTS: createRequestTypes('payments', 'GET_PAYMENTS'),
  MOODBOARD_PRODUCTS: createRequestTypes('moodboard', 'MOODBOARD_PRODUCTS'),
  GET_SPACE_MOODBOARD_PRODUCTS: createRequestTypes(
    'moodboard',
    'GET_SPACE_MOODBOARD_PRODUCTS'
  ),
  GET_SPACE: createRequestTypes('space', 'GET_SPACE'),
  GET_SPACE_LATEST: createRequestTypes('spaceLatest', 'GET_SPACE_LATEST'),
  CREATE_SPACE: createRequestTypes('createSpace', 'CREATE_SPACE'),
  STYLEBOARD_INFO: createRequestTypes('yourProject', 'STYLEBOARD_INFO'),
  SUBMIT_STYLEBOARD_INFO: createRequestTypes(
    'yourProject',
    'SUBMIT_STYLEBOARD_INFO'
  ),
  GET_STYLE_QUIZ: createRequestTypes('styleQuiz', 'GET_STYLE_QUIZ'),
  POST_STYLE_QUIZ: createRequestTypes('styleQuiz', 'POST_STYLE_QUIZ'),
  GET_ORDER_INFO: createRequestTypes('orderInfo', 'GET_ORDER_INFO'),
  GET_PACKAGES_DATA: createRequestTypes('packages', 'GET_PACKAGES_DATA'),
  UPDATE_CART: createRequestTypes('updateCart', 'UPDATE_CART'),
  MESSAGE_STAFF: createRequestTypes('messageStaff', 'MESSAGE_STAFF'),
  GET_RETAILER_LOGO: createRequestTypes('retailPartner', 'GET_RETAILER_LOGO'),
  GET_RETAILER_REFERRAL_QUESTION: createRequestTypes('retailPartner', 'GET_RETAILER_REFERRAL_QUESTION')
};

// retail partner actions
export const SET_RETAIL_PARTNER = 'SET_RETAIL_PARTNER';

// /project/your-recommendation constants
export const RECOMMENDATION_STAFF_MESSAGE_SUBJECT =
  'Pre-purchase - "Learn More" Comments/Questions';

export const CONSULTATION_CHOICES = {
  BEFORE: 1,
  AFTER: 2
};

export const FAVORITE_BRANDS_DISABLED_PARTNERS = [
  CRATE_AND_BARREL_URL_QUERY_CODE,
  CB2_URL_QUERY_CODE,
  OVERSTOCK_URL_QUERY_CODE
];

export const S3_PRODUCT_BASE_URL = (reactAppEnv => {
  let envUrl;

  switch (reactAppEnv) {
    case 'prod':
      envUrl = '';
      break;
    case 'staging':
      envUrl = '-staging';
      break;
    default:
      envUrl = '-dev';
  }

  return `https://modsy${envUrl}.s3.amazonaws.com/`;
})(process.env.REACT_APP_ENV);

export const PRODUCT_AVAILABILITY_STATUSES = {
  MADE_TO_ORDER: -6,
  DISCONTINUED: -5,
  BACKORDER: -4,
  REGION: -3,
  ONLINE: -2,
  AVAILABLE: -1,
  UNAVAILABLE: 0
};

export const PRODUCT_TAG_CATEGORIES = {
  'accessory': 'Accessories',
  'bar cart': 'Bar Carts',
  'bar stool': 'Bar Stools',
  'bed': 'Beds',
  'bookcase': 'Bookcases',
  'cabinet': 'Cabinets',
  'chair': 'Chairs',
  'chandelier': 'Chandelier',
  'coffee table': 'Coffee Tables',
  'desk': 'Desks',
  'dining chair': 'Dining Chairs',
  'dining table': 'Dining Tables',
  'dresser': 'Dressers',
  'floor lamp': 'Floor Lamps',
  'lighting': 'Lighting',
  'media console': 'Media Consoles',
  'mirror': 'Mirrors',
  'nightstand': 'Nightstands',
  'ottoman': 'Ottomans',
  'pillow': 'Pillows',
  'plant': 'Plants',
  'rug': 'Rugs',
  'side table': 'Side Tables',
  'sectional': 'Sectionals',
  'sofa': 'Sofas',
  'stool': 'Stools',
  'storage': 'Storage',
  'table': 'Tables',
  'table lamp': 'Table Lamps',
  'tv stand': 'TV Stands',
  'wall art': 'Wall Art',
  'wall shelf': 'Wall Shelves'
};

// rewards tiers
export const INSIDER_REWARDS_TIERS = {
  500: 50,
  1000: 100,
  2500: 250
};

export const PRODUCT_LIKE = 1;
export const PRODUCT_NEUTRAL = 0;
export const PRODUCT_DISLIKE = -1;

/**
 * The package SKU for the showroom/express package.
 */
export const SHOWROOM_PACKAGE_SKU = 'Modsy_Shwrm_Pckg';

/**
 * Modsy design package SKUs.
 */
export const MODSY_PACKAGE_BASIC = '3D_Room_Model';
export const MODSY_PACKAGE_CLASSIC = 'Modsy_Plus_Pckg';
export const MODSY_PACKAGE_PREMIUM = 'Mod_Des_Pac_199';
export const MODSY_PACKAGE_MULTIROOM = 'platinum_package';
export const MODSY_PACKAGE_LUXE = 'LUXE_1';
export const MODSY_EXPRESS_DELIVERY_BASIC = 'XPRS_DLVRY_BSC';
export const MODSY_EXPRESS_DELIVERY_PREMIUM = 'XPRS_DLVRY_PRM';
export const MODSY_EXPRESS_DELIVERY_MULTI_ROOM = 'XPRS_DLVRY_MLT';
export const MODSY_PACKAGE_CUSTOM = 'custom_package';

export const MODSY_PREMIUM_ONEROOM = 'PMR_1';
export const MODSY_PREMIUM_TWOROOMS = 'PMR_2';
export const MODSY_PREMIUM_THREEROOMS = 'PMR_3';
export const MODSY_PREMIUM_FOURROOMS = 'PMR_4';
export const MODSY_PREMIUM_FIVEROOMS = 'PMR_5';
export const MODSY_PREMIUM_SIXROOMS = 'PMR_6';
export const MODSY_PREMIUM_SEVENROOMS = 'PMR_7';
export const MODSY_PREMIUM_EIGHTROOMS = 'PMR_8';

export const MODSY_PREMIUM_ONEROOM_EXPEDITED = 'XPRS_PMR_1';
export const MODSY_PREMIUM_TWOROOMS_EXPEDITED = 'XPRS_PMR_2';
export const MODSY_PREMIUM_THREEROOMS_EXPEDITED = 'XPRS_PMR_3';
export const MODSY_PREMIUM_FOURROOMS_EXPEDITED = 'XPRS_PMR_4';
export const MODSY_PREMIUM_FIVEROOMS_EXPEDITED = 'XPRS_PMR_5';
export const MODSY_PREMIUM_SIXROOMS_EXPEDITED = 'XPRS_PMR_6';
export const MODSY_PREMIUM_SEVENROOMS_EXPEDITED = 'XPRS_PMR_7';
export const MODSY_PREMIUM_EIGHTROOMS_EXPEDITED = 'XPRS_PMR_8';

export const EXPEDITE_PREFIX = 'XPRS_';

export const EXPEDITE_FREE = 'Free';

export const MODSY_LUXE_PREFIX = 'LUXE_';

export const MODSY_LUXE_ONEROOM = 'LUXE_1';
export const MODSY_LUXE_TWOROOMS = 'LUXE_2';
export const MODSY_LUXE_THREEROOMS = 'LUXE_3';
export const MODSY_LUXE_FOURROOMS = 'LUXE_4';
export const MODSY_LUXE_FIVEROOMS = 'LUXE_5';
export const MODSY_LUXE_SIXROOMS = 'LUXE_6';
export const MODSY_LUXE_SEVENROOMS = 'LUXE_7';
export const MODSY_LUXE_EIGHTROOMS = 'LUXE_8';

export const MODSY_RENO_S = 'RENO_S';
export const MODSY_RENO_M = 'RENO_M';
export const MODSY_RENO_L = 'RENO_L';
export const MODSY_RENO_MR2 = 'RENO_MR2';
export const MODSY_RENO_MR3 = 'RENO_MR3';
export const MODSY_RENO_MR4 = 'RENO_MR4';
export const MODSY_RENO_MR5 = 'RENO_MR5';
export const MODSY_RENO_MR6 = 'RENO_MR6';
export const MODSY_RENO_MR7 = 'RENO_MR7';
export const MODSY_RENO_MR8 = 'RENO_MR8';
export const MODSY_RENO_MR9 = 'RENO_MR9';
export const MODSY_RENO_MR10 = 'RENO_MR10';
export const MODSY_RENO_MR11 = 'RENO_MR11';
export const MODSY_RENO_MR12 = 'RENO_MR12';
export const MODSY_RENO_MR13 = 'RENO_MR13';
export const MODSY_RENO_MR14 = 'RENO_MR14';
export const MODSY_RENO_MR15 = 'RENO_MR15';
export const MODSY_RENO_MR16 = 'RENO_MR16';
export const MODSY_RENO_MR17 = 'RENO_MR17';
export const MODSY_RENO_MR18 = 'RENO_MR18';
export const MODSY_RENO_MR19 = 'RENO_MR19';
export const MODSY_RENO_MR20 = 'RENO_MR20';

export const MODSY_RENO_DISABLED = [
  MODSY_RENO_M,
  MODSY_RENO_L
];

export const PREMIUM_SKUS = [
  MODSY_PREMIUM_ONEROOM_EXPEDITED,
  MODSY_PREMIUM_TWOROOMS_EXPEDITED,
  MODSY_PREMIUM_THREEROOMS_EXPEDITED,
  MODSY_PREMIUM_FOURROOMS_EXPEDITED,
  MODSY_PREMIUM_FIVEROOMS_EXPEDITED,
  MODSY_PREMIUM_SIXROOMS_EXPEDITED,
  MODSY_PREMIUM_SEVENROOMS_EXPEDITED,
  MODSY_PREMIUM_EIGHTROOMS_EXPEDITED,
  MODSY_PREMIUM_ONEROOM,
  MODSY_PREMIUM_TWOROOMS,
  MODSY_PREMIUM_THREEROOMS,
  MODSY_PREMIUM_FOURROOMS,
  MODSY_PREMIUM_FIVEROOMS,
  MODSY_PREMIUM_SIXROOMS,
  MODSY_PREMIUM_SEVENROOMS,
  MODSY_PREMIUM_EIGHTROOMS
];

export const LUXE_SKUS = [
  MODSY_LUXE_ONEROOM,
  MODSY_LUXE_TWOROOMS,
  MODSY_LUXE_THREEROOMS,
  MODSY_LUXE_FOURROOMS,
  MODSY_LUXE_FIVEROOMS,
  MODSY_LUXE_SIXROOMS,
  MODSY_LUXE_SEVENROOMS,
  MODSY_LUXE_EIGHTROOMS
];

export const RENO_MULTIROOM_SKUS = [
  MODSY_RENO_S,
  MODSY_RENO_MR2,
  MODSY_RENO_MR3,
  MODSY_RENO_MR4,
  MODSY_RENO_MR5,
  MODSY_RENO_MR6,
  MODSY_RENO_MR7,
  MODSY_RENO_MR8,
  MODSY_RENO_MR9,
  MODSY_RENO_MR10,
  MODSY_RENO_MR11,
  MODSY_RENO_MR12,
  MODSY_RENO_MR13,
  MODSY_RENO_MR14,
  MODSY_RENO_MR15,
  MODSY_RENO_MR16,
  MODSY_RENO_MR17,
  MODSY_RENO_MR18,
  MODSY_RENO_MR19,
  MODSY_RENO_MR20
];

export const MULTI_ROOM_SKUS = [
  ...PREMIUM_SKUS,
  ...LUXE_SKUS,
  ...RENO_MULTIROOM_SKUS
];

// maps multi-room package skus to the sku for a single room
export const ONE_ROOM_MAP = {
  [MODSY_PREMIUM_ONEROOM]: MODSY_PREMIUM_ONEROOM,
  [MODSY_PREMIUM_TWOROOMS]: MODSY_PREMIUM_ONEROOM,
  [MODSY_PREMIUM_THREEROOMS]: MODSY_PREMIUM_ONEROOM,
  [MODSY_PREMIUM_FOURROOMS]: MODSY_PREMIUM_ONEROOM,
  [MODSY_PREMIUM_FIVEROOMS]: MODSY_PREMIUM_ONEROOM,
  [MODSY_PREMIUM_SIXROOMS]: MODSY_PREMIUM_ONEROOM,
  [MODSY_PREMIUM_SEVENROOMS]: MODSY_PREMIUM_ONEROOM,
  [MODSY_PREMIUM_EIGHTROOMS]: MODSY_PREMIUM_ONEROOM,
  [MODSY_LUXE_ONEROOM]: MODSY_LUXE_ONEROOM,
  [MODSY_LUXE_TWOROOMS]: MODSY_LUXE_ONEROOM,
  [MODSY_LUXE_THREEROOMS]: MODSY_LUXE_ONEROOM,
  [MODSY_LUXE_FOURROOMS]: MODSY_LUXE_ONEROOM,
  [MODSY_LUXE_FIVEROOMS]: MODSY_LUXE_ONEROOM,
  [MODSY_LUXE_SIXROOMS]: MODSY_LUXE_ONEROOM,
  [MODSY_LUXE_SEVENROOMS]: MODSY_LUXE_ONEROOM,
  [MODSY_LUXE_EIGHTROOMS]: MODSY_LUXE_ONEROOM,
  [MODSY_RENO_MR2]: MODSY_RENO_S,
  [MODSY_RENO_MR3]: MODSY_RENO_S,
  [MODSY_RENO_MR4]: MODSY_RENO_S,
  [MODSY_RENO_MR5]: MODSY_RENO_S,
  [MODSY_RENO_MR6]: MODSY_RENO_S,
  [MODSY_RENO_MR7]: MODSY_RENO_S,
  [MODSY_RENO_MR8]: MODSY_RENO_S,
  [MODSY_RENO_MR9]: MODSY_RENO_S,
  [MODSY_RENO_MR10]: MODSY_RENO_S,
  [MODSY_RENO_MR11]: MODSY_RENO_S,
  [MODSY_RENO_MR12]: MODSY_RENO_S,
  [MODSY_RENO_MR13]: MODSY_RENO_S,
  [MODSY_RENO_MR14]: MODSY_RENO_S,
  [MODSY_RENO_MR15]: MODSY_RENO_S,
  [MODSY_RENO_MR16]: MODSY_RENO_S,
  [MODSY_RENO_MR17]: MODSY_RENO_S,
  [MODSY_RENO_MR18]: MODSY_RENO_S,
  [MODSY_RENO_MR19]: MODSY_RENO_S,
  [MODSY_RENO_MR20]: MODSY_RENO_S
};

export const PACKAGE_ROOM_NUMBERS = {
  [MODSY_PREMIUM_ONEROOM]: 1,
  [MODSY_PREMIUM_TWOROOMS]: 2,
  [MODSY_PREMIUM_THREEROOMS]: 3,
  [MODSY_PREMIUM_FOURROOMS]: 4,
  [MODSY_PREMIUM_FIVEROOMS]: 5,
  [MODSY_PREMIUM_SIXROOMS]: 6,
  [MODSY_PREMIUM_SEVENROOMS]: 7,
  [MODSY_PREMIUM_EIGHTROOMS]: 8,
  [MODSY_LUXE_ONEROOM]: 1,
  [MODSY_LUXE_TWOROOMS]: 2,
  [MODSY_LUXE_THREEROOMS]: 3,
  [MODSY_LUXE_FOURROOMS]: 4,
  [MODSY_LUXE_FIVEROOMS]: 5,
  [MODSY_LUXE_SIXROOMS]: 6,
  [MODSY_LUXE_SEVENROOMS]: 7,
  [MODSY_LUXE_EIGHTROOMS]: 8,
  [MODSY_PACKAGE_CLASSIC]: 1,
  [MODSY_PACKAGE_MULTIROOM]: 3,
  [MODSY_PACKAGE_BASIC]: 1,
  [MODSY_PACKAGE_CLASSIC]: 1,
  [MODSY_PACKAGE_PREMIUM]: 1,
  [MODSY_RENO_S]: 1,
  [MODSY_RENO_MR2]: 2,
  [MODSY_RENO_MR3]: 3,
  [MODSY_RENO_MR4]: 4,
  [MODSY_RENO_MR5]: 5,
  [MODSY_RENO_MR6]: 6,
  [MODSY_RENO_MR7]: 7,
  [MODSY_RENO_MR8]: 8,
  [MODSY_RENO_MR9]: 9,
  [MODSY_RENO_MR10]: 10,
  [MODSY_RENO_MR11]: 11,
  [MODSY_RENO_MR12]: 12,
  [MODSY_RENO_MR13]: 13,
  [MODSY_RENO_MR14]: 14,
  [MODSY_RENO_MR15]: 15,
  [MODSY_RENO_MR16]: 16,
  [MODSY_RENO_MR17]: 17,
  [MODSY_RENO_MR18]: 18,
  [MODSY_RENO_MR19]: 19,
  [MODSY_RENO_MR20]: 20
};

/**
 * Partner design Package SKUs.
 */
export const CB2_PACKAGE_SKU = '3D_CB2_Package';
export const CB2_PLUS_PACKAGE_SKU = '3DSA_CB2_Package';
export const CRATE_AND_BARREL_PACKAGE_SKU = '3D_Crate_Package';
export const WEST_ELM_PACKAGE_SKU = '3D_W-Elm_Package';

export const FREE_PROP_PACKAGE_SKU = 'free-custom-prop';
export const PAID_PROP_PACKAGE_SKU = 'CUSTOM_PRODUCT_1';

/**
 * Design package TATs.
 * Consider moving this to server.
 */
export const TAT_V3 = {
  [MODSY_PACKAGE_BASIC]: '2-3 weeks', // Basic package has been deprecated
  [MODSY_PACKAGE_CLASSIC]: '2-3 weeks', // Classic package has been deprecated
  [MODSY_PACKAGE_PREMIUM]: '2-3 weeks',
  [MODSY_PREMIUM_TWOROOMS]: '2-3 weeks',
  [MODSY_PACKAGE_MULTIROOM]: '2-3 weeks',
  [MODSY_PACKAGE_LUXE]: '2-3 weeks',
  [MODSY_PREMIUM_ONEROOM]: '2-3 weeks',
  [SHOWROOM_PACKAGE_SKU]: '< 1 hour'
};

const PACKAGE_COMMUNICATION_MSG = 'Communicate via email or phone';

export const PACKAGE_DISPLAY_TEXT = {
  [MODSY_PACKAGE_CLASSIC]: {
    badge: '',
    name: 'Classic',
    discountedPrice: '$199',
    description: 'When you want to jump-start your project with personalized designs.',
    bullets: [
      'Work with rising star designers',
      'Communicate via email',
      '2 revisions of your design with a designer'
    ]
  },
  [MODSY_PREMIUM_ONEROOM]: {
    badge: 'Recommended',
    name: 'Premium',
    discountedPrice: '$299',
    description: 'When you need a little more hands-on help and attention with your project.',
    bullets: [
      'Work 1:1 with an established designer',
      PACKAGE_COMMUNICATION_MSG,
      'Unlimited revisions of your design with a designer'
    ]
  },
  [MODSY_PREMIUM_TWOROOMS]: {
    badge: 'Best Deal',
    name: 'Multi-Room',
    discountedPrice: '$598',
    description: 'Our Premium service across 2 rooms. Add more rooms for additional discounts.',
    bullets: [
      'Work 1:1 with a designer to get a cohesive look across multiple rooms',
      PACKAGE_COMMUNICATION_MSG,
      'Unlimited revisions of your design per room'
    ]
  },
  [MODSY_PACKAGE_LUXE]: {
    badge: '',
    name: 'Luxe',
    discountedPrice: '$1499',
    description: 'Get an experience similar to working with a traditional interior designer, but with all the convenience of online design. Including everything in Premium plus:',
    bullets: [
      'A full-service experience with a top-tier designer',
      PACKAGE_COMMUNICATION_MSG,
      'Paint and window treatment recommendations available'
    ]
  }
};

export const PACKAGE_BADGES = {
  [SHOWROOM_PACKAGE_SKU]: {
    color: grey,
    text: 'TRY US OUT'
  },

  [MODSY_PREMIUM_ONEROOM]: {
    color: blue,
    text: 'RECOMMENDED'
  },

  [MODSY_PREMIUM_TWOROOMS]: {
    color: red,
    text: 'BEST DEAL'
  },

  [MODSY_PACKAGE_CUSTOM]: {
    color: redTint,
    text: 'NEW'
  }
};

export const PACKAGE_YOUGET_TEXT = {
  [SHOWROOM_PACKAGE_SKU]: `One 3D design in our standard template room.`,

  [MODSY_PACKAGE_CLASSIC]: `Designs in a 3D model of your exact room, two revisions with the Modsy design team via email, and the confidence that all your purchases will look and fit great.`,

  [MODSY_PREMIUM_ONEROOM]: `Everything in the Classic package plus unlimited redesigns, priority customer service and a single, dedicated designer to work with you from start-to-finish via phone or email.`,

  [MODSY_PREMIUM_TWOROOMS]: `Everything in the Premium package x3, so you can work with your dedicated designer on personalized and cohesive designs for multiple rooms.`,

  [MODSY_PACKAGE_CUSTOM]: `Tell us what you're looking for, and we'll get back to you with a custom quote in 24-48 hours.`
};

export const PACKAGE_CUSTOM_TEXT = {
  description: `Don't see an option that fits your needs? Customize your own Modsy design package for an experience perfectly tailored to you!`,
  displayName: 'Custom',
  displayPrice: '$200 - $1000',
  sku: MODSY_PACKAGE_CUSTOM,

  // For this test, we will be sending user's to a Google Form
  // to collect information on what they want. Ops will then
  // put together a custom quote and contact the user directly.
  href: `https://docs.google.com/forms/d/e/1FAIpQLSfKEtN9aVlb-7OkPR-9j_0i0QX1JMOXQSnNPnh_kNBAhDeeXQ/viewform?vc=0&c=0&w=1`,

  // The You Get section is customized for this package and includes feature bullets.
  youGetTitle: `All Custom packages include everything in Premium, plus the option to add on:`,
  youGetFeatures: [
    '• Additional rooms',
    '• Paint colors',
    '• Structural changes',
    '• Build from a floor plan',
    '• Expedited service',
    '• More!'
  ]
};

// select options
export const Months = [
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12'
];
export const Years = [
  '2016',
  '2017',
  '2018',
  '2019',
  '2020',
  '2021',
  '2022',
  '2023',
  '2024',
  '2025',
  '2026',
  '2027',
  '2028'
];
export const US_STATES = [
  'AL',
  'AR',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'IA',
  'ID',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MI',
  'MN',
  'MO',
  'MS',
  'MT',
  'NC',
  'ND',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NV',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VA',
  'VT',
  'WA',
  'WI',
  'WV',
  'WY'
];

const PACKAGE_COMPARE_COMM_TEXT = 'Email or Phone';

// feature rows in comparison modal
export const PACKAGE_COMPARE_FEATURES = {
  sameDesigner: {
    name: 'The same designer across multiple rooms',
    package1: false,
    package2: false,
    package3: true
  },
  tat: {
    name: 'Draft design delivery time',
    package1: '1-2 weeks',
    package2: '1-2 weeks',
    package3: '1-2 weeks'
  },
  upgradeMultipleRooms: {
    name: 'Option to upgrade to multiple rooms',
    package1: false,
    package2: true,
    package3: true
  },
  wallPaintRecommendations: {
    name: 'Wall paint recommendations',
    package1: false,
    package2: false,
    package3: true
  },
  windowTreatmentRecommendations: {
    name: 'Window treatment recommendations',
    package1: false,
    package2: false,
    package3: true
  },
  designerCommunication: {
    name: 'Communication with your designer',
    package1: 'Email',
    package2: PACKAGE_COMPARE_COMM_TEXT,
    package3: PACKAGE_COMPARE_COMM_TEXT
  },
  fullServiceExperience: {
    name: 'Full-service experience from a top-tier designer',
    package1: false,
    package2: false,
    package3: true
  },
  numRevisions: {
    name: 'Number of design revisions',
    package1: '2',
    package2: 'Unlimited',
    package3: 'Unlimited'
  },
  personalizedDesigns: {
    name: 'Personalized designs based on your style and budget',
    package1: true,
    package2: true,
    package3: true
  },
  useDesignTools: {
    name: 'Unlimited use of 3D design tools',
    package1: true,
    package2: true,
    package3: true
  },
  easyCheckout: {
    name: 'Purchase items in one easy checkout',
    package1: true,
    package2: true,
    package3: true
  },
  shoppingTeam: {
    name: 'Our team handles all ordering details',
    package1: true,
    package2: true,
    package3: true
  },
  exclusivePricing: {
    name: '$150 off your first purchase of $1500+',
    package1: true,
    package2: true,
    package3: true
  },
  exactRoom: {
    name: 'Shoppable 3D designs of your room',
    package1: true,
    package2: true,
    package3: true
  },
  dedicatedDesigner: {
    name: 'Work 1:1 with a dedicated Modsy Designer',
    package1: false,
    package2: true,
    package3: true
  },
  skipQueue: {
    name: 'Skip the queue with priority service',
    package1: false,
    package2: false,
    package3: true
  }
};

export const ERROR_MESSAGES = {
  ORDER_FAIL: 'Order Fail',
  NO_MULTI_ROOM_PACKAGE: 'Could not find package for multi-room option'
};

export const PAYMENT_METHOD_TYPES = {
  NEW_CC: 'New CC'
};

export const WLH_KEYS = {
  adults: 'adults',
  teens: 'teens',
  bigKids: 'bigKids',
  littleKids: 'littleKids',
  babies: 'babies',
  cats: 'cats',
  dogs: 'dogs',
  otherPets: 'otherPets'
};

export const SHARED_VIEW_TYPE = 'shared';

export const SHARE_COPY_TEXT = 'Copied to clipboard';

export const DEFAULT_DESIGN_NOTE_COPY = 'No style notes found for this design.';

// Layouts need to use a different set of ids than normal designs
// because the first two designs are assumed to be Modsy designs
// our current solution is to offset the layout ids by this amount
// (commented out for now since it is unused, but the value should
// be available in the FE somewhere)
export const LAYOUT_ID_OFFSET = 30000;

// maximum number of layouts supported by the BE
export const LAYOUTS_MAX = 10;

export const CONTACT_PHONE_COPY = {
  title: 'Get messages from Modsy, fast.',
  subTitle: 'Mobile phone number',
  phonePlaceholder: '(201) 555-5555',
  textingSubtitle: 'Can we text you about your project?',
  buttonYes: 'Yes, please text me',
  buttonNo: 'No, thanks',
  textingCopyYes: 'You’re giving Modsy permission to send you SMS text messages. This will include messages about your design projects and orders you place with Modsy. SMS messages may be subject to fees and limitations by your mobile carrier. See Modsy’s complete ',
  textingCopyNo: email => `All messages will be sent by email instead of text. Please be sure to check your email ${email} regularly during your design project.`
};

export const CONTACT_PHONE_COPY_MONARCH = {
  mobilePhoneTitle: 'Mobile phone number',
  phonePlaceholder: '(201) 555-5555',
  textingSubtitle: 'Do you want to receive text updates on your project?',
  buttonYes: 'Yes, please text me',
  buttonNo: 'No, thanks',
  textingCopyYes: 'You’re giving Modsy permission to send you SMS text messages. This will include messages about your design projects and orders you place with Modsy. SMS messages may be subject to fees and limitations by your mobile carrier. See Modsy’s complete ',
  textingCopyNo: email => `All messages will be sent by email instead of text. Please be sure to check your email ${email} regularly during your design project.`
};

export const PROP_TYPE_FIND_ALTERNATIVE_REQUEST = 1;
export const PROP_TYPE_ALTERNATIVE_PRODUCT = 2;
export const PROP_TYPE_CUSTOM_PRODUCT = 3;

/**
 * PDP and Add to Cart limit
 */
export const MAX_PRODUCT_COUNT_QUANTITY = 30;

export const HAS_COMPLETED_STYLE_QUIZ = 'hasCompletedStyleQuiz';
export const IS_REGISTERED_FROM_BLOG = 'isRegisteredFromBlog';
